import React, { useState } from 'react';
import Axios from 'axios';
import { useTranslation } from "react-i18next";
import CONFIG from '../../config';
import { toastMessage } from '../../utils/toast';
import customAxios from '../../Redux/Actions/axios';

const Localization = () => {

    const [file, setFile] = useState('');
    const { t } = useTranslation();

    const handleUpload = () => {
        const data = new FormData();
        data.append("file", file);
        customAxios.post(CONFIG.apiURL + `/Localization/PostCsv`, data).then(res => {
            try {
                toastMessage('info', `File Uploaded`);
                setFile('');
            } catch (error) {
                console.log('err', error)
                toastMessage('error', "Something went wrong during file download!!");
            }
        }).catch(err => {
            console.log('Unable to download the file', err);
        });
    }

    const handleDownload = () => {
        customAxios.get(CONFIG.apiURL + `/Localization/GetCsv`).then(res => {
            try {
                toastMessage('info', `Download in progress`);
                var blob = new Blob(["\ufeff", res.data]);
                var link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                var fileName = 'localization.csv';
                link.download = fileName;
                link.click();
            } catch (error) {
                console.log('err', error)
                toastMessage('error', "Something went wrong during file download!!");
            }
        }).catch(err => {
            console.log('Unable to download the file', err);
        });
    }

    return(
        <div className="container-fluid">
            <div className="row">
                <div className="col-sm-12">
                    <div className="page-title-box">
                        <div className="row">
                            <div className="col">
                                <h4 className="page-title">{t("localization.title")}</h4>
                            </div>
                        </div>
                        <div className="mt-4 d-flex align-items-center justify-content-center" style={{height: '70vh'}}>
                            <div className="d-flex">
                                <div>
                                    <h5 className="">{t("localization.extractLocalization")}</h5>
                                    <button type="button" className="d-flex align-items-center btn btn-primary font-weight-bold mt-3" onClick={handleDownload}>
                                        {t("localization.download")}
                                    </button>
                                </div>
                                <div className="mx-5">
                                    <h5 className=" mb-3">{t("localization.uploadLocalization")}</h5>
                                    <div className="dropify-wrapper c-pointer position-relative p-4" style={{width: '242px'}}>
                                        {(file === '') && <div className="dropify-message">
                                            <span className="file-icon"><p>{t("localization.dragDrop")}</p></span>
                                        </div>}
                                        <input type="file" className="dropify" style={{opacity: 0}} onChange={e => setFile(e.target.files[0])} accept=".csv" />
                                        <div className="dropify-preview text-center">{file.name}</div>
                                        {/* {(file !== '') && <button type="button" className="dropify-clear">Remove</button>} */}
                                    </div>
                                    <button disabled={file === ''} type="button" className="btn btn-primary font-weight-bold mt-3" onClick={handleUpload}>
                                        {t("localization.upload")}
                                    </button>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Localization;